import API from "../api/axios";


export const facebookLogin = () => {
   return API.get("/facebook/login");
};

export const getFacebookIntegration = () => {
   return API.get("/facebook/integration");
};

export const getFacebookForms = () => {
   return API.get("/facebook/forms");
};

export const updateFacebookForm = (id, data) => {
   return API.put(`/facebook/forms/${id}`, data);
};

export const syncFacebookForms = () => {
   return API.get("/facebook/forms/sync");
};


export const disconnectFacebook = () => {
   return API.post("/facebook/disconnect");
};

export const syncFacebookLeads = (pageId) => {
   return API.post("/facebook/sync-leads", {
      pageId
   });
};